// extracted by mini-css-extract-plugin
export default {"title":"VideoTitle_title__VwqUj"};